import React from "react";
import PropTypes from "prop-types";
import {
  Box,
  Typography,
  Grid,
  useTheme,
  useMediaQuery,
  Container
} from "@material-ui/core";

import CardProducts from "../CardProducts";

import { useStyles } from "../../hooks";
import styles from "./styles";
import InfiniteCarousel from "react-leaf-carousel";

const SectionOurProducts = ({ listCards = [] }) => {
  const classes = useStyles(styles);
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up("sm"));

  return (
    <Box component="section" className={classes.root} style={{zIndex:0, position:'relative'}}>
      <Container>
        <Box mb="50px" display="flex" justifyContent="center">
          <Typography variant="h2" className={classes.title} align="center">
            Nuestros <b>productos</b>
          </Typography>
        </Box>
        {!matches ? (
          <Box className={styles.sliderContainer}>
            <InfiniteCarousel
              breakpoints={[
                {
                  breakpoint: theme.breakpoints.values.xs,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                  },
                },
                {
                  breakpoint: theme.breakpoints.values.sm,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                  },
                },
              ]}
              dots={false}
              showSides={true}
              sidesOpacity={0.5}
              sideSize={0.1}
              slidesToScroll={0}
              arrows={false}
              slidesToShow={0}
            >
              {listCards.map(card => (
                <CardProducts {...card} key={card.id}/>
              ))}
            </InfiniteCarousel>
          </Box>
        ) : (
          <Grid container spacing={3} justifyContent="center">
            {listCards.map(card => (
              <Grid key={card.id} item md={3}>
                <CardProducts {...card} />
              </Grid>
            ))}
          </Grid>
        )}
      </Container>
    </Box>
  );
};

SectionOurProducts.propTypes = {
  listCards: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      icon: PropTypes.elementType.isRequired,
      borderRadius: PropTypes.oneOf([
        "not-top-left",
        "not-top-right",
        "not-bottom-right",
        "not-bottom-left",
        "all"
      ])
    })
  ).isRequired
};

export default SectionOurProducts;
